import styled, { css } from 'styled-components';
import { rgba } from 'polished';

// Import components
import { Button } from 'components/elements/atoms/Button/Button';

// Import styles
import { flex, customMinResponsive, size, transitionMain } from 'components/styles';

// Import assets
import { ReactComponent as IconInfo } from 'assets/icons/ic_info.svg';

export const Container = styled.div`
	${flex({ jc: 'space-between' })}
	background-color: ${({ theme }) => rgba(theme.configurator.bg.contrast, 0.95)};
	padding: 1.4rem;
	position: relative;
	width: 100%;
	z-index: 2;

	${customMinResponsive(
		size.semi,
		css`
			padding: 1.4rem 3rem;
		`
	)}

	${customMinResponsive(
		size.large,
		css`
			padding: 1.4rem 6.5rem;
		`
	)}
`;

export const MessageWrapper = styled.div`
	${flex()}
	gap: 0.75rem;
`;

export const Message = styled.p`
	color: ${({ theme }) => theme.configurator.color.dark};
	font-weight: ${({ theme }) => theme.font.distinct};
	font-size: 1.2rem;

	${customMinResponsive(
		size.semi,
		css`
			font-size: 1.6rem;
		`
	)}
`;

export const ButtonsWrapper = styled.div`
	${flex({ fd: 'column' })}
	padding-left: 2rem;
	min-width: 50vw;

	${customMinResponsive(
		size.xsmall,
		css`
			${flex({ fd: 'row', jc: 'space-between' })}
			min-width: 38rem;
		`
	)}
`;

export const StyledIconInfo = styled(IconInfo)`
	color: ${({ theme }) => theme.configurator.color.dark};
	min-width: 2.3rem;
	min-height: 2.3rem;
	${transitionMain()}
`;

export const StyledButton = styled(Button)`
	padding: 1rem;
`;
